import {
  DropdownDownOutline24Icon,
  DropdownRightOutline24Icon,
} from "@vygruppen/spor-icon-react";
import { Subgrid } from "features/CenterContent/RoleContent/EventHandling/components/Subgrid";
import { FC, ReactNode, useState } from "react";
import { AlertsCounter } from "shared/components/dataDisplay/AlertsCounter";
import { Box, DropsButton, Flex, tokens } from "shared/components/Spor";
import styled from "styled-components";

const ExpandablePanel = styled.div`
  display: grid;
  overflow: hidden;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;

  grid-template-rows: 100%;

  transition: grid-template-rows 0.5s;

  &[aria-hidden="true"] {
    grid-template-rows: 0;
  }
`;

type CollapsibleSectionProps = {
  label: string;
  counter: number;
  children?: ReactNode;
  rightContent?: ReactNode;
  mt?: string;
  backgroundColor?: string;
};

const CollapsibleSection: FC<CollapsibleSectionProps> = ({
  label,
  counter,
  children,
  rightContent,
  mt,
  backgroundColor,
}) => {
  const [isClosed, setIsClosed] = useState(false);

  return (
    <Subgrid
      gap="0"
      width="100%"
      maxWidth="1800px"
      backgroundColor={backgroundColor}
      mt={mt}
      gridTemplateRows="[header] 42px [content] 1fr"
    >
      <Subgrid gridRow="content">
        <ExpandablePanel aria-hidden={isClosed}>{children}</ExpandablePanel>
      </Subgrid>

      <Box
        position="sticky"
        top="0"
        width="100%"
        backgroundColor={backgroundColor}
        gridColumn="1 / -1"
        gridRow="header"
      >
        <Flex
          flexDirection="row"
          alignItems="start"
          justifyContent="start"
          mr="auto"
          gap={tokens.default.size.spacing[1]}
          my={tokens.default.size.spacing[0.5]}
        >
          <DropsButton
            onClick={() => setIsClosed(!isClosed)}
            size="sm"
            aria-label={isClosed ? "Åpne" : "Lukke"}
            variant="ghost"
            outline="none"
            paddingInline={2}
            leftIcon={
              isClosed ? (
                <DropdownRightOutline24Icon />
              ) : (
                <DropdownDownOutline24Icon />
              )
            }
          >
            {label}{" "}
            <AlertsCounter
              alerts={counter}
              semantics="transparent"
              displayWhenZero
              mr={tokens.default.size.spacing[1]}
            />
          </DropsButton>
          <Box ml="auto" mr="1px">
            {rightContent}
          </Box>
        </Flex>
      </Box>
    </Subgrid>
  );
};

export default CollapsibleSection;
